import { FC } from 'react';
import { useIssueDetailDataQuery } from '../../hooks';
import { Typography } from '../../../../../components/Typography';
import { PaddingBox } from '../../../../../components/PaddingBox';
import { useTranslationAPI } from '../../../../translations';
import { codes } from '../../../../../data/translations';
import { isBadOrEmptyString } from '../../../../../predicates/string';
import { IssueDetailAddressSkeleton } from './IssueDetailAddressSkeleton';
import RouteLink from '../../../../../components/RouteLink';

export const IssueDetailAddress: FC = () => {
	const { translate } = useTranslationAPI();
	const {
		data: { address },
		isLoading,
	} = useIssueDetailDataQuery();

	const hasPostalAddress =
		!isBadOrEmptyString(address.postAddressStreet) && !isBadOrEmptyString(address.postAddressNumber);
	const hasEmail = !isBadOrEmptyString(address.organizationEmail);

	return (
		<>
			<PaddingBox bottomTiny>
				<Typography
					headingSize={1}
					bold
					fontSize='20px'
				>
					{translate(codes.organization.address)}
				</Typography>
			</PaddingBox>
			{!isLoading && (
				<>
					<Typography display='block'>{address.organizationName}</Typography>
					<Typography display='block'>
						{address.contactAddressStreet} {address.contactAddressNumber} {address.contactAddressUnit}
					</Typography>
					<Typography display='block'>
						{address.contactAddressPostalCode} {address.contactAddressCity}
					</Typography>
					{hasPostalAddress && (
						<>
							<Typography display='block'>
								{translate(codes.organization.postBox)} {address.postAddressStreet}
							</Typography>
							<Typography display='block'>
								{address.postAddressNumber} {address.postAddressUnit}
							</Typography>
						</>
					)}
					<Typography display='block'>
						{address.postAddressPostalCode} {address.postAddressCity}
					</Typography>
					{hasEmail && (
						<>
							{translate(codes.common.email)}:{' '}
							<RouteLink
								hasColor={false}
								href={`mailto:${address.organizationEmail}`}
								target='_blank'
							>
								{address.organizationEmail}
							</RouteLink>
						</>
					)}
				</>
			)}
			{isLoading && <IssueDetailAddressSkeleton />}
		</>
	);
};
